import Box from 'components/shared/Box'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import DateTitle from 'components/shared/DateTitle'
import { FormattedMessage } from 'react-intl'
import ParkTicket from 'routes/selfcare/views/ManageOrder/tickets/ParkTicket'
import { sortDates } from 'helpers/helpers'
import { TicketReservation } from 'store/selfcare-slice/types'

interface ManageTicketsProps {
    tickets: TicketReservation[]
}

const ManageTickets = ({ tickets }: ManageTicketsProps) => {
    const ticketDays = sortDates(
        Array.from(
            new Set(
                tickets.map(
                    (ticket) =>
                        ticket[`${ticket.changes ? 'changes' : 'original'}`]
                            .detail.day
                )
            )
        )
    )

    return (
        <Section id="manage-tickets" hasSmallerSpacingsX hasSmallerSpacingsY>
            <Text variant="heading2" color="grayscale_900" mb={[24, 40]}>
                <FormattedMessage
                    id="selfcare.tickets.section_caption"
                    defaultMessage="Bilety"
                />
            </Text>
            <Box gap={[24, 40]}>
                {ticketDays.map((day, index) => {
                    const ticketsPerDay = tickets.filter(
                        (ticket) =>
                            ticket[`${ticket.changes ? 'changes' : 'original'}`]
                                .detail.day === day
                    )

                    return (
                        <Box gap={16} isFullWidth key={`ticket-${day}`}>
                            <DateTitle index={index + 1} date={day} />

                            {ticketsPerDay.map((ticket, ticketIndex) => (
                                <ParkTicket
                                    ticket={ticket}
                                    key={ticket.original.detail.orderTicketId}
                                    index={index * 10 + ticketIndex}
                                />
                            ))}
                        </Box>
                    )
                })}
            </Box>
        </Section>
    )
}

export default ManageTickets
